import classNames from 'classnames';
import * as React from 'react';
import styles from './IconButton.module.css';
export default function IconButton(props) {
    var _a;
    var _b;
    var status = (_b = props.status) !== null && _b !== void 0 ? _b : 'enabled';
    return (React.createElement("button", { id: props.id, type: 'button', onClick: function (event) {
            props.onClick(event);
        }, className: classNames(styles.buttonTrash, (_a = {},
            _a[styles.buttonTrashBlue] = props.design === 'trash-blue',
            _a[styles.buttonClose] = props.design === 'close',
            _a[styles.buttonEdit] = props.design === 'edit',
            _a[styles.buttonGo] = props.design === 'go',
            _a[styles.buttonGoInactive] = props.design === 'go' && props.status === 'disabled',
            _a)), disabled: status !== 'enabled' }));
}
